import { ERA_LOOKS } from '@continuum/show-core';
import type { TaskDef } from '@continuum/show-core';
import { Screen } from '../../ui/Shell.js';
import { Eyebrow, Lede, Spacer, mono } from '../../ui/atoms.js';
import { TaskQueue } from '../../ui/TaskQueue.js';
import type { QueueRow } from '../../ui/TaskQueue.js';
import type { ScreenCopy } from '../../ui/screenText.js';

/** Era 2 — The Boom. The city is a picture; the game is in the list. */
export function PerfectCity({
  rows,
  s,
  title,
  onOpen,
}: {
  rows: QueueRow[];
  s: ScreenCopy;
  title: (def: TaskDef) => string;
  onOpen: (row: QueueRow) => void;
}) {
  const look = ERA_LOOKS[2];
  const tile = (border: string, bg: string, anim?: string) => ({
    border: `1px solid ${border}`,
    borderRadius: 8,
    background: bg,
    animation: anim,
  });

  return (
    <Screen style={{ background: 'linear-gradient(180deg,#0d0618,#150a24)', color: '#f4e9ff', padding: 24 }}>
      <Eyebrow color="#3ff2e6">{s.era2Eyebrow}</Eyebrow>
      <h1 style={{ margin: '12px 0 6px', fontSize: 24, fontWeight: 700, letterSpacing: 2 }}>{s.era2Title}</h1>
      <Lede color="#b795cf">{s.era2Lede}</Lede>

      <div
        style={{
          margin: '20px auto 0',
          display: 'grid',
          gridTemplateColumns: 'repeat(3,64px)',
          gridTemplateRows: 'repeat(3,64px)',
          gap: 6,
          flex: 'none',
        }}
      >
        <div style={tile('rgba(255,255,255,.14)', 'rgba(255,255,255,.04)')} />
        <div style={tile('rgba(63,242,230,.5)', 'rgba(63,242,230,.10)', 'ccGlow 2.4s ease-in-out infinite')} />
        <div style={tile('rgba(255,255,255,.14)', 'rgba(255,255,255,.04)')} />
        <div style={tile('rgba(180,79,255,.5)', 'rgba(180,79,255,.10)', 'ccGlow 3.1s ease-in-out .6s infinite')} />
        <div
          style={{
            border: '1.5px solid #ff4fd8',
            borderRadius: 8,
            background: 'rgba(255,79,216,.16)',
            boxShadow: '0 0 24px rgba(255,79,216,.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: mono,
            fontSize: 11,
            letterSpacing: 1,
            color: '#ffb3ec',
            textAlign: 'center',
          }}
        >
          {s.era2You}
        </div>
        <div style={tile('rgba(63,242,230,.5)', 'rgba(63,242,230,.10)', 'ccGlow 2.4s ease-in-out infinite')} />
        <div style={tile('rgba(255,255,255,.14)', 'rgba(255,255,255,.04)')} />
        <div style={tile('rgba(180,79,255,.5)', 'rgba(180,79,255,.10)', 'ccGlow 3.1s ease-in-out .6s infinite')} />
        <div style={tile('rgba(255,255,255,.14)', 'rgba(255,255,255,.04)')} />
      </div>

      <TaskQueue rows={rows} look={look} s={s} title={title} onOpen={onOpen} labelColor="#3ff2e6" />
      <Spacer min={12} />
    </Screen>
  );
}
